var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.864,
    height: 21.167,
    viewBox: "0 0 19.864 21.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 19.864,
    height: 21.167,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(-686 -969.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(686 969.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M705.6,988.293l-4.9-5.1a8.353,8.353,0,1,0-1.6,1.464l4.943,5.141a1.083,1.083,0,0,0,1.534.03,1.086,1.086,0,0,0,.03-1.535Zm-11.275-16.6a6.151,6.151,0,1,1-6.15,6.15,6.159,6.159,0,0,1,6.15-6.15Zm0,0",
    transform: "translate(-686 -969.398)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9b9f13b9.svg";
export { ForwardRef as ReactComponent };